import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/zillehuma/zysoftec/source/app/Components/service/servicecards.tsx");
